import style from './index.module.css'

import React from 'react'

import { Flex, Text } from 'components/ds'

type TrackMetadataProps = { title: string; artist: string }

export const TrackMetadata = ({ title, artist }: TrackMetadataProps) => {
  return (
    <Flex
      direction="column"
      gap="1"
      width="50%"
      className={style.TrackMetadata_Container}
      translate="no"
    >
      <Text as="p" weight="medium" size="2" className={style.Text_TrackTitle}>
        {title}
      </Text>
      <Text as="p" size="1" className={style.Text_TrackArtist}>
        {artist}
      </Text>
    </Flex>
  )
}
